module.exports = __webpack_public_path__ + "img/cert.d11f4324.png";